import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@qgiv/core-react";
import ConnectedEarlyRegistrationChipContent from "./ConnectedEarlyRegistrationChipContent";

const EarlyRegistrationChip = ({ categoryId }) => (
    <Chip bgColor="theme-primary">
        <ConnectedEarlyRegistrationChipContent categoryId={categoryId} />
    </Chip>
);

EarlyRegistrationChip.propTypes = {
    categoryId: PropTypes.number.isRequired,
};

export default EarlyRegistrationChip;
